import React from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HeroSlider = () => {
  const navigate = useNavigate();

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 30000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slides = [
    {
      title: "No more juggling multiple tools",
      features: [
        {
          heading: "One Platform, Total Control",
          description:
            "Manage calls, messages, and customer interaction seamlessly in one app.",
        },
        {
          heading: "Reliable & Secure",
          description: "99.999% uptime SLA and enterprise-grade security.",
        },
        {
          heading: "Never Miss a Call",
          description:
            "A virtual receptionist ensures every call is answered and routed instantly.",
        },
      ],
      image: "/assets/images/new_index/ladywithtelephone.svg",
      buttons: [
        { label: "Get your Demo", link: "/demo" },
        { label: "Try for Free", link: "/signup" },
      ],
    },
    {
      title: "Communication Simplified with NxaTel",
      features: [
        {
          heading: "More Conversations, Less Admin",
          description: "Automate call routing, logging, and follow-ups.",
        },
        {
          heading: "Crystal-Clear Communication",
          description: "Enjoy high-quality calls and seamless connections.",
        },
        {
          heading: "Never Miss a Lead",
          description:
            "Calls are answered and directed to the right person instantly.",
        },
      ],
      image: "/assets/images/new_index/Manwithtablet.svg",
      buttons: [
        { label: "See Pricing", link: "/pricing" },
        { label: "Get your Demo", link: "/demo" },
      ],
    },
  ];

  return (
    <section className="hero-slider">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div className="hero-slider__slide" key={index}>
            <div className="hero-slider__container">
              <div className="hero-slider__content">
                {slide.title && (
                  <h1 className="hero-slider__title">{slide.title}</h1>
                )}
                <ul className="hero-slider__features">
                  {slide.features.map((feature, idx) => (
                    <li className="hero-slider__feature" key={idx}>
                      <span className="hero-slider__feature-heading">
                        {feature.heading}
                      </span>
                      <p className="hero-slider__feature-description">
                        {feature.description}
                      </p>
                    </li>
                  ))}
                </ul>
                <div className="hero-slider__buttons">
                  {slide.buttons.map((btn, i) => {
                    const isPrimary =
                      btn.label.toLowerCase().includes("try") ||
                      btn.label.toLowerCase().includes("see");
                    const isOrange =
                      slide.title === "No more juggling multiple tools";

                    const color = isOrange ? "orange" : "red";
                    const variant = isPrimary ? "primary" : "outline";

                    return (
                      <button
                        key={i}
                        onClick={() => navigate(btn.link)}
                        className={`btn btn--${variant} btn--${color}`}
                      >
                        {btn.label}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="hero-slider__image">
                <img src={slide.image} alt="Hero Visual" loading="lazy" />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroSlider;
